import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentBookPath, Mp4Path } from '../../../asset/utils/Constant';
import { setFullscreen } from '../../../store/CommonSlice';
import { setCurrentTime, setDuration, setDurationTime, setPlay, setRange } from '../../../store/VideoSlice';

const VideoTag = styled.video`
  width: 768px;
  height: 432px;
`;

export const Video = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const player = useRef();

  document.addEventListener("fullscreenchange", () => {
    if (!document.fullscreenElement && !state.common.fullscreen) {
      dispatch(setFullscreen(false));
    }
  });

  useEffect(() => {
    player.current.load();

    dispatch(setPlay(true));
    
    player.current.play();
  }, [state.video.video_src])

  useEffect(() => {
    if (state.common.fullscreen) {
      if (!document.fullscreenElement) {
        player.current.requestFullscreen();
      }
    } else {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
  }, [state.common.fullscreen]);

  useEffect(() => {
    state.video.play ? player.current.play() : player.current.pause();
  }, [state.video.play]);

  // progress bar 조정
  useEffect(() => {
    if (player.current.currentTime) {
      player.current.currentTime = state.video.change_time;
    } 
  }, [state.video.change_time]);

  const onTimeUpdate = (e) => {
    // 현재 재생 시간
    player.current && dispatch(setCurrentTime(player.current.currentTime));

    // progress bar
    player.current && dispatch(setRange((100 * parseInt(player.current.currentTime)) / parseInt(player.current.duration)));
  };

  return (
    <VideoTag 
      ref={player}
      onTimeUpdate={(e) => {
        onTimeUpdate(e);
      }}
      onLoadedMetadata={() => {
        dispatch(setCurrentTime(player.current.currentTime));
        dispatch(setDurationTime(player.current.duration));
        dispatch(setDuration(player.current.duration))
        dispatch(setPlay(true));
      }}
    >
      <source src={ContentBookPath + (state.book.current_book + 1) + Mp4Path + state.video.video_src + '.mp4'} type="video/mp4" />
    </VideoTag>
  );
};